import React from 'react';
import { Box, Typography } from '@mui/material';
import { SxProps } from '@mui/system';

type Props = {
  children: React.ReactNode;
  description: string;
  title: string;
  sx?: SxProps;
  marginBottom?: number;
  descriptionMaxWidth?: string;
};
export const ConfigSection = ({
  title,
  description,
  sx,
  children,
  marginBottom = 3,
  descriptionMaxWidth,
}: Props) => {
  return (
    <Box component="section" sx={sx}>
      <Typography
        sx={{
          mb: 1,
          mr: 1.5,
          color: '#000',
          fontFamily: 'Poppins, sans-serif',
          fontSize: 14,
          fontStyle: 'normal',
          fontWeight: 600,
          lineHeight: '18px',
          fontFeatureSettings: "'liga' off, 'clig' off",
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="small"
        color="text.secondary"
        sx={{ mb: marginBottom, ...(descriptionMaxWidth ? { maxWidth: descriptionMaxWidth } : {}) }}
      >
        {description}
      </Typography>
      {children}
    </Box>
  );
};
